
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("knzfV", function(module, exports) {

$parcel$export(module.exports, "ClassificationEditModal", () => $5cd13874f5033207$export$d7e008c8afea1e79);

var $gwFzn = parcelRequire("gwFzn");

var $ekolh = parcelRequire("ekolh");
var $6xdDU = parcelRequire("6xdDU");

var $9wGTI = parcelRequire("9wGTI");

var $dIouf = parcelRequire("dIouf");

var $40pD8 = parcelRequire("40pD8");

var $fGQzQ = parcelRequire("fGQzQ");

var $l4l51 = parcelRequire("l4l51");

var $earLp = parcelRequire("earLp");

var $8KSlr = parcelRequire("8KSlr");
const $5cd13874f5033207$export$d7e008c8afea1e79 = ({ contentId: contentId, spaceKey: spaceKey, contentClassificationMetadata: contentClassificationMetadata })=>{
    const { isClassificationModalOpen: isClassificationModalOpen } = (0, $40pD8.useClassificationModalContext)();
    const { setIsClassificationModalOpen: setIsClassificationModalOpen } = (0, $40pD8.useClassificationModalDispatchContext)();
    const { trackEditPopupViewed: trackEditPopupViewed } = (0, $earLp.useTrackClassificationAnalytics)();
    const handleSubmit = (0, $fGQzQ.useEditSubmitCallback)({
        contentId: contentId,
        contentClassificationMetadata: contentClassificationMetadata
    });
    const { classification: classification, spaceDefaultIsOverridden: spaceDefaultIsOverridden, // TODO: remove these two below, once fg('dlp_cc-minimize-classifications-queries) is removed
    spaceClassification: spaceClassificationOld, getClassificationLevelFromId: getClassificationLevelFromIdOld } = contentClassificationMetadata;
    const { defaultClassificationOption: defaultOptionFromHook, error: classificationOptionError } = (0, $l4l51.useComputeDefaultClassificationDropdownOption)({
        getClassificationLevelFromId: getClassificationLevelFromIdOld,
        spaceDefaultClassificationLevel: spaceClassificationOld,
        skipQuery: (0, $9wGTI.fg)('dlp_cc-minimize-classifications-queries')
    });
    const defaultClassificationOption = (0, $9wGTI.fg)('dlp_cc-minimize-classifications-queries') ? undefined : defaultOptionFromHook;
    const defaultSelectedEditOption = spaceDefaultIsOverridden ? classification : defaultClassificationOption;
    const onEditSubmit = (0, $gwFzn.useCallback)((classificationOption)=>{
        handleSubmit(classificationOption);
        setIsClassificationModalOpen(false);
    }, [
        handleSubmit,
        setIsClassificationModalOpen
    ]);
    const onEditCancel = (0, $gwFzn.useCallback)(()=>{
        setIsClassificationModalOpen(false);
    }, [
        setIsClassificationModalOpen
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (isClassificationModalOpen) trackEditPopupViewed((0, $earLp.ActionSubjectId).GENERIC_DATA_CLASSIFICATION_MODAL_POPUP);
    }, [
        isClassificationModalOpen,
        trackEditPopupViewed
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6xdDU.default), null, isClassificationModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ekolh.default), {
        onClose: ()=>setIsClassificationModalOpen(false),
        width: "330px"
    }, classificationOptionError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorDisplay), {
        error: classificationOptionError
    }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $8KSlr.ClassificationEditViewPopup), {
        onEditSubmit: onEditSubmit,
        onEditCancel: onEditCancel,
        selectedOption: defaultSelectedEditOption ?? undefined,
        defaultOption: defaultClassificationOption,
        spaceKey: spaceKey
    })));
};

});


//# sourceMappingURL=ClassificationEditModal.baa11f72.js.map
